import { Marker } from 'react-map-gl'
import { Coordinates } from '../types'

interface PinProps {
  coordinates: Coordinates
  onClick?: (event) => void
  color?: string
}

export const Pin: React.FC<PinProps> = ({ coordinates, onClick, color }) => {
  const { latitude, longitude } = coordinates
  if (onClick)
    return (
      <Marker
        longitude={longitude}
        latitude={latitude}
        anchor="bottom"
        onClick={event => {
          event.originalEvent.stopPropagation()
          onClick(event)
        }}
      >
        <CustomMarker color={color} />
      </Marker>
    )
  return (
    <Marker longitude={longitude} latitude={latitude} anchor="bottom">
      <CustomMarker color={color} />
    </Marker>
  )
}

const ICON = `M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm0-384a64 64 0 1 1 0 128 64 64 0 1 1 0-128z`

const pinStyle: React.CSSProperties = {
  cursor: 'pointer',
  fill: '#d00',
  stroke: 'none'
}

const CustomMarker = ({ color }: { color?: string }) => {
  return (
    <svg height="2em" viewBox="0 0 384 512" style={color ? { ...pinStyle, fill: color } : pinStyle}>
      <path d={ICON} />
    </svg>
  )
}
